import {register} from 'dna-react-ioc'
import {IDigitalReceiptsButtonsStore} from '~/code/pages/DigitalReceipts/components/DigitalReceiptsButtons'
import {DigitalReceiptsButtonsSymbol} from '~/code/pages/DigitalReceipts/components/DigitalReceiptsButtons/DigitalReceiptsButtons'
import {DigitalReceiptsButtonsStore} from '~/code/stores/digital-receipts'

export const digitalReceiptsState = () => {
    register<IDigitalReceiptsButtonsStore>(DigitalReceiptsButtonsSymbol)
        .to(DigitalReceiptsButtonsStore)
        .inSingletonScope()
}
